import { useTranslation } from 'react-i18next';

import pushRouter from 'hooks/useRouterHelper';
import useQueryParams from 'hooks/useQueryParams';

import './StudyBottomBar.scoped.scss';

interface Props {
  name: string;
  param: string;
  icon?: React.ReactNode;
}

const IndividualStudyBar: React.FC<Props> = ({ name, param, icon }) => {
  const { routePush } = pushRouter<{
    section: string;
  }>();

  const { section } = useQueryParams();
  const { t } = useTranslation('study');

  return (
    <>
      <div
        key={section?.toString()}
        onClick={() => {
          const conditionedSection = section !== param ? param : '';
          routePush({
            search: {
              section: conditionedSection,
            },
          });
          window.scroll({
            left: 0,
            top: document.getElementById('notes-and-discussion-id').offsetTop,
          });
        }}
        className={section === param && 'active'}
      >
        <p>{t(`${name}`)}</p>
        {icon}
      </div>
    </>
  );
};

export default IndividualStudyBar;
